const TYPE_ID_SUBSCRIPTION_BOX = 2;
const TYPE_ID_ON_DEMAND_SERVICE = 3;
const TYPE_ID_EXPERIENCE = 4;
const TYPE_ID_DONATION = 5;
const TYPE_ID_GIFT_CARD = 6;
const TYPE_ID_BRANDED_PRODUCT = 7;

export default {
  TYPE_ID_SUBSCRIPTION_BOX,
  TYPE_ID_ON_DEMAND_SERVICE,
  TYPE_ID_EXPERIENCE,
  TYPE_ID_DONATION,
  TYPE_ID_GIFT_CARD,
  TYPE_ID_BRANDED_PRODUCT,
};
